export default __webpack_public_path__ + "static/media/info-icon.c74c2e9e.svg";